import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
declare let alertify: any;

@Injectable({
    providedIn: 'root'
})
export class MessagesService {

    public

    constructor(private router: Router) { }

    viewError(message: string) {
        alertify.alert('Error Detectado', message).set('closable', false);;
    }

    viewErrors(messages: string[]) {
        alertify.alert('Error Detectado', this.getMessage(messages)).set('closable', false);
    }

    viewSuccess(message: string) {
        alertify.alert('Operación Exitosa', message).set('closable', false);
    }
    
    viewWarning(message: string) {
        alertify.alert('Advertencia', message).set('closable', false);
    }
    
    viewWarnings(messages: string[]) {
        alertify.alert('Advertencia', this.getMessage(messages)).set('closable', false);;
    }

    private getMessage(messages: string[]):string {
        let message = '';
        for (let i = 0; i < messages.length; i++) {
            message += '<br>' + messages[i] + '</br>';
        }
        return message;
    }
    
    checkError(error: any,defaultMessage : string) {
        if (error.status == 403) {
            this.viewError("No se poseen permisos. " + defaultMessage);
        } else if (error.status == 401) {
            this.viewError("La sesión ha expirado.");
            this.router.navigate(['/login']);
        } else {
            let json = error.json();
            if (json.messages != null) {
                this.viewErrors(json.messages);
            } else if (json.message != null) {
                this.viewError(json.message);
            } else {
                this.viewError(defaultMessage);
            }
        }
    }

}
